(function($){

	var isHome = $('body').hasClass('home'),
		isPage = $('body').hasClass('page'),
		isMobile = 'ontouchstart' in window,
		contentTop = $('header').first().height(),
		
		banner = $('#site-banner'),
		scrollUp = $('.scroll-up'),
		sixMaps = $('.sixsquare-map'),
		sliders = $('.slickSlider'),
		touchhover = $('.touchhover'),
		headerHero = $('header.header .hero').first(),
		
		hasScrolled = false,
		windowWidth = 0;
	
	var IO = window.IntersectionObserver || null;
		
$(document).ready(function() {
	
	// Slick Slider
	sliders.each(function() {
		$(this).on('init',function(e,slick){
			var t = $(this),
				h = t.height();
			if ( slick.options.centerMode ) t.addClass('centerMode');
			if ( ! t.hasClass('hero') ) t.height(h);
			else {
				// Tagline color initial
				var slide = t.find('.slick-slide').first(),
					color = slide.data('taglinecolor'),
					tag = t.parent().find('.tagline');
				
				if ( typeof color == 'string' && color.length ) tag.addClass( color ).data( 'color', color );
			}
			
		}).on('reInit',function(e,slick) {
			var t = $(this),
				h = t.css('height','').height();
				if ( ! t.hasClass('hero') ) t.height(h);
		
		}).on('beforeChange',function(e,slick,currentSlide,nextSlide) {
			var t = $(this);
			if ( t.hasClass('hero') ) {
				// Tagline color change
				var slide = t.find('.slick-slide').eq(nextSlide),
					color = slide.data('taglinecolor'),
					tag = t.parent().find('.tagline'),
					oldColor = tag.data('color');
				
				if ( color != oldColor ) {
					if ( typeof color == 'string' && color.length ) tag.addClass( color ).data( 'color', color );
				
					tag.removeClass( oldColor );
				}
			}
			
		}).slick({
			// Default options
			centerPadding: '20%',
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 600,
			responsive: [
				{ 	breakpoint: 1680,
					settings: {
						centerPadding: '15%'
					}
				}
			]
		});
	});
	
	// Scrolling with throttle
	$(window).on('scroll', Foundation.util.throttle( function (event) {
	
		var wTop = $(this).scrollTop();
			
		// Google Maps
		if ( sixMaps.length ) {
			sixMaps.each(function(i, el) {
				el = $(el);
				if ( el.visible('middle') ) { 
					sixSquareMapFeatures( el );
					sixMaps = sixMaps.not(this);
				}
			});
		}
				
		// Scroll Up widget
		if ( wTop > contentTop ) scrollUp.addClass('visible');
		else scrollUp.removeClass('visible');
			
	}, 300) ).scroll();
	
	if ( headerHero.length ) {
		// Watch header hero intersection
		const header_hero_io = new IO(function(entries) {
			$.each(entries,function(ii,entry) {
				if ( !hasScrolled && entry.intersectionRatio < 0.85 ) {
					hasScrolled = true;
				}
			});
		}, { threshold: [0.01,0.8] });
		header_hero_io.observe(headerHero[0]);
		
		// Auto Scroll!?
		setTimeout( function() {
			
			if ( !isHome && !hasScrolled ) {
				$('.scroll-down_container').click();
			}
			
		}, 3500 );
	}


	// Set default VH unit for mobile (Safari toolbar full height fix)
	var setVH = function () {
		if ( isMobile && $(window).width() != windowWidth ) {
			windowWidth = $(window).width();
			var vh = window.innerHeight * 0.01; // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
			document.documentElement.style.setProperty('--vh', `${vh}px`);
			contentTop = $('header').first().height();
		}
	}; setVH();
	
	// Resize with throttle
	$(window).on('resize', Foundation.util.throttle( function (event) {
	
		sliders.each(function() {
			var t = $(this),
				h = t.css('height','').height();
				if ( ! t.hasClass('hero') ) t.height(h);

		});

		setVH();	
		
		if ( banner.length ) banner.height( banner.children('.message')[0].scrollHeight );
			
	}, 300) );
	
	// Off Canvas links: close on click. This ensures the menu is hidden when navigating back. Reducing the transition was somehow necessary. It is fixed by onClick code in nav-offcanvas-topbar.php. The callback below doesn't get called.
	$('#off-canvas a').click(function(){
		if ( $(this).parent().hasClass('is-accordion-submenu-parent') ) return true;
		return $('#off-canvas').css('transition','all 0.1s').foundation('close',function(){ 
			$('#off-canvas').css('transition','');
			return true;
		}); 

	});

	// Off-Canvas Open
	$('#off-canvas').on('opened.zf.offCanvas', function (e) {
		
		$('body').addClass('is-open-left');
		
	});
	
	// Off-Canvas Open Ended
	$('#off-canvas').on('openedEnd.zf.offCanvas', function (e) {
		
		document.activeElement.blur();
		
	});

	// Off-Canvas Close
	$('#off-canvas').on('close.zf.offCanvas', function (e) {
		
		$('body').removeClass('is-open-left'); 
		
	});

	// Off-Canvas accordion menu OPEN
	$('#offcanvas-nav').foundation('showAll');
	
	// Touch hover methods
	if ( isMobile ) {
		touchhover.on('touchstart', function(e) {
			var t = $(this);
			
			if ( t.hasClass('hover') ) {
				return true;
			} else {
				t.addClass('hover');
				touchhover.not(this).removeClass('hover');
				e.preventDefault();
				return false;
			}
			
		});
		$('body').on('touchstart',function(e) {
			touchhover.removeClass('hover');
		});
	}

	// SVG load
	$('img.svg-load').each( function() { 
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		$.get({
			url: imgURL,
			cache: true,
			dataType: 'xml',
			success: function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');
				// Add replaced image's ID to the new SVG
				if(typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if(typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass);
				}
				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');
				// Replace image with new SVG
				$img.replaceWith($svg);
			}
		});
	});
	
	// Hide Site banner if dismissed this session
	if (	banner.length 
		 &&	typeof sessionStorage.bannerClosed == 'string'
		 &&	sessionStorage.bannerClosed == banner.data('aid') 
	   ) {
		
		banner.removeClass('open');
		banner = [];
	   	
	} else {
	
		// Annoucement Close
		banner.find('.close').click(function() {
			banner.addClass('closed');
			sessionStorage.bannerClosed = banner.data('aid');
			banner = [];
		});
	
	}
	
	// Easy Grid Slider
	var gS = $('.gridSlider').data('gridSliderPos',0); 
	$('<button class="gS_prev"></button><button class="gS_next"></button>').appendTo(gS)
		.click(function(){
			var t = $(this);
			var gS = t.parent('.gridSlider');
			var cur = gS.data('gridSliderPos');
			var move = ( t.hasClass('gS_prev') ? -1 : 1 );
			var slides = gS.children('.cell');
			var maxed = ( ( gS.width() - 1 ) > ( slides.last().position().left ) );
			if ( ( ! maxed || move < 0 ) && (cur + move) >= 0 ) {
				gS.removeClass('gs-' + cur);
				gS.addClass('gs-' + (cur + move) ).data('gridSliderPos', cur + move);
			}
		});
	
	// Orbit
/*	$('document,body').on('init.zf.orbit', function() {
		console.log('ORBITTED 1');
	});
	$('.orbit').on('init.zf.orbit', function() {
		console.log('ORBITTED 2');
	});
	$('document,body').on('init.zf.Orbit', function() {
		console.log('ORBITTED 1b');
	});
	$('.orbit').on('init.zf.Orbit', function() {
		console.log('ORBITTED 2b');
	});
*/	
	// banners
	$('.banner .close').click(function() {
		var t =  $(this).parent(),
			closed = sessionStorage.bannersClosed;
		
		t.addClass('closed');
		
		sessionStorage.bannersClosed = ( typeof closed == 'string' ? closed + ',' : '' ) + t.data('id');
	});	
	
	// Scroll Up widget
	scrollUp.on("click", function(){
		var t = Math.round((scrollUp.offset().top/500) * 300);
		$('html, body').animate({ scrollTop: 0 }, t, 'easeOutCubic');
	});

	// Scroll Down widget
	$('.scroll-down_container').click(function(){
		var t = (contentTop/500) * 800;
		$('html, body').animate({ scrollTop: contentTop }, t, 'swing');
	});

}); // document.ready()

$(window).on('load', function() {

	// Page Loader trigger
	$('#pageLoader').addClass('out');
	
	// BODY ANIMATION TRIGGER
	$('body').removeClass('pre-init');
	
});


// Breakpoint Change
$(window).on('changed.zf.mediaquery ready', function(event, newSize, oldSize) {
	if ( typeof newSize == 'undefined' ) newSize = Foundation.MediaQuery.current;

	if ( newSize == 'small' ) {
		
	} else if ( oldSize == 'small' ) {

	} 
	if ( newSize && oldSize ) { // actual change, not first call (ready)
		
		// Easy Grid Slider reset
		$('.gridSlider').each( function() {
			var gS = $(this);
			var cur = gS.data('gridSliderPos');
			gS.removeClass('gs-' + cur).data('gridSliderPos',0);
		});
		
	}
});

// Has Visited
visited = sessionStorage.hasVisited;
if ( typeof visited == 'string' && visited == 'true' ) $('body').addClass('has-visited');
else sessionStorage.hasVisited = 'true';
	
// banners
if ( typeof sessionStorage.bannersClosed == 'string' ) {
	var ids = sessionStorage.bannersClosed.split(",");
	$('.banner').each(function() {
		var t = $(this),
			id = t.data('id').toString();
		if ( ids.indexOf( id ) > -1 ) {
//			console.log('ANNC DESTROY ' + id);
			t.closest('.orbit-slide').remove();
		}
	});
//	console.log('ANNC DESTROY done');
}

// Gravity Forms: FORM POST RENDER (This includes initial form load, going to the next/previous page on multi-page forms, form rendered with validation errors, confirmation message displayed, etc.)
$(document).bind('gform_post_render', function(event,formID){
	
	
});

// Google Maps Callback fn
window.sixSquareMapInit = function () {
	// Create a new StyledMapType object, passing it an array of styles,
	// and the name to be displayed on the map type control.
	var styledMapType = new google.maps.StyledMapType([
	  {
		"elementType": "geometry",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"elementType": "labels.text.stroke",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#bdbdbd"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [{
			"color": "#ffffff"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [{
			"color": "#dadada"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "transit",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [{
			"color": "#80bac5"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  }
	], {name: 'Styled Map'});
	
	sixMaps.each(function() {
	
		var googleMap = new google.maps.Map( this, {
			zoom: 15,
			center: new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ),
			mapTypeId: 'roadmap',
			mapTypeControl: false,
			fullscreenControl: false,
			streetViewControl: false,
			scrollwheel: false,
			"featureType": "poi.business",
			"stylers": [
				{
					"visibility": "off"
				}
			]		
		});

		//Associate the styled map with the MapTypeId and set it to display.
		googleMap.mapTypes.set('styled_map', styledMapType);
		googleMap.setMapTypeId('styled_map');
		
		$(this).data('gmap', googleMap);
	
	});

}
// Google Maps Feature / pin / display fn
function sixSquareMapFeatures( map ) {

	if ( typeof map != 'object' ) return false;
	
	var googleMap = map.data('gmap');

	if ( typeof map.data('gmapMarkers') == 'undefined' ) {
		// First init!
		var features = [
			{
				position: new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ),
				type: 'info',
				title: sixScript.blogname ,
				animation: google.maps.Animation.DROP
			}
		];
		var icon = {
			url: sixScript.gmap_icon,
			scaledSize: new google.maps.Size(34,43),
			origin: new google.maps.Point(0,0),
			anchor: new google.maps.Point(17,21)
		};
		// Create markers.
		map.data('gmapMarkers',[]);

		features.forEach(function(feature) {
		  var marker = new google.maps.Marker({
			position: feature.position,
			map: googleMap,
			icon: icon,
			animation: feature.animation,
			title: feature.title
		  });
		  map.data('gmapMarkers').push(marker);
		});

	} else {

		// reinit
		googleMap.setCenter( new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ) );
		map.data('gmapMarkers')[0].setAnimation( google.maps.Animation.DROP );
		
	}
	
}
		
// fn: Visible
$.fn.visible = function(type) {
	var t            = $(this);
	if ( typeof t.offset() != "object" ) { console.log('visible: not object.'); console.log(this); return false; }
	var	$w            = $(window),
		viewTop       = $w.scrollTop(),
		viewBottom    = viewTop + $w.height(),
		_height		  = t.height(),
		_top          = t.offset().top,
		_middle		  = _top + (_height/2),
		_bottom       = _top + _height,
		_10			  = _height*0.1;
		
		switch (type) {
			case 'top': return (_top +_10 >= viewTop) && (_top < viewBottom);
			case 'top20': return ( _top + _10*2 >= viewTop ) && (_top + _10*2 < viewBottom);
			case 'top30': return ( _top + _10*3 >= viewTop ) && (_top + _10*3 < viewBottom);
			case 'middle': return (_middle >= viewTop) && (viewBottom >= _middle);
			case 'bottom': return (_bottom + _10 >= viewTop) && ( _bottom < viewBottom);
			case 'any': return ( (_top > viewTop ) && ( _top < viewBottom ) ) || ( ( _bottom > viewTop ) && (_bottom < viewBottom ) );
			//case 'full':
			default: return (_bottom <= viewBottom) && (_top >= viewTop);
		}
};

// jQuery Easings
$.extend( $.easing, {
	easeOutCubic: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t + 1) + b;
		}
});
/*
	// Orbit
	$('document,body').on('init.zf.orbit', function() {
		console.log('ORBITTED 3');
	});
	$('.orbit').on('init.zf.orbit', function() {
		console.log('ORBITTED 4');
	});
	$('document,body').on('init.zf.Orbit', function() {
		console.log('ORBITTED 3b');
	});
	$('.orbit').on('init.zf.Orbit', function() {
		console.log('ORBITTED 4b');
	});
	
*/

})(jQuery);